//
//
//
//
//
//
//

import PersonalSection from './personal_section.vue'
export default {
    components: {
        PersonalSection
    },
    computed: {
        tabs () {
            const tabs = [
                {
                    icon: 'feedback',
                    name: '建议反馈',
                    url: '/pages/personal_package/feedback/main'
                },
                {
                    icon: 'office',
                    name: '小程序',
                    url: '/pages/packageA/min-app/main'
                },
                {
                    icon: 'notice',
                    name: '服务声明',
                    url: '/protocal/user'
                },
                {
                    icon: 'contact',
                    name: '联系我们',
                    url: '/pages/packageA/contact_us/main'
                }
            ]
            return tabs
        }
    }
}
